import RmOlkCd from "components/select/rm/rmOlkCd";
import RmTypCd from "components/select/rm/rmTypCd";
import { SEARCH_ID_FORM_ROOM_PRODUCT } from "components/constent";
import TableRow from "components/rows/tableRow";
import Radio from "components/rows/radio";
import { useTranslation } from "react-i18next";
import { regNum } from "components/utils/comm";
import { useProductFilterContext } from "./context";
import { useSubmit } from "./handles";
import RmNmSelect from "components/select/rm/rmNo";
// import DatePick from "components/datePick";
import Cell from "components/rows/cell";
import LodChlSelect from "components/select/lod/lodChl";
import DateRangePicker from "components/datePicker";

type ISearchProps = {};

export default function SearchForm({}: ISearchProps) {
  const { t } = useTranslation();

  const { filters, onChange, onSelect, onPickDate, onReset } =
    useProductFilterContext();

  const { onSubmit } = useSubmit();

  return (
    <>
      <form
        id={SEARCH_ID_FORM_ROOM_PRODUCT}
        onSubmit={onSubmit}
        onReset={onReset}
      >
        <table>
          <tbody>
            <TableRow title={t("row_ttl_rm_inf")}>
              <ul>
                <li>
                  <label htmlFor="">{t("lbl_rm_nm")}</label>
                  <RmNmSelect
                    isReset={!filters.rmNo}
                    select={(rmNo) => {
                      onSelect("rmNo", rmNo);
                    }}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rm_olk")}</label>
                  <RmOlkCd
                    isReset={!filters.rmOlkCd}
                    select={(rmOlkCd) => onSelect("rmOlkCd", rmOlkCd)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rm_typ")}</label>
                  <RmTypCd
                    isReset={!filters.rmTypCd}
                    select={(rmTypCd) => onSelect("rmTypCd", rmTypCd)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_max_per_ct")}</label>
                  <input
                    type="text"
                    name="maxPerCtMax"
                    data-type="C"
                    value={filters.maxPerCtMax}
                    onChange={(e) => {
                      const value = e.currentTarget.value;
                      if (!regNum.test(value)) return;
                      if (regNum.test(value)) {
                        onChange("maxPerCtMax", value);
                      }
                    }}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_min_per_ct")}</label>
                  <input
                    type="text"
                    name="maxPerCtMin"
                    data-type="C"
                    onChange={(e) => {
                      const value = e.currentTarget.value;
                      if (!regNum.test(value)) return;
                      if (regNum.test(value)) {
                        onChange("maxPerCtMin", value);
                      }
                    }}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_rm_op_nm")}
                    dataTyp="C"
                    name="rmOpNm"
                    value={filters.rmOpNm}
                    onChange={(e) => onChange("rmOpNm", e.currentTarget.value)}
                  />
                </li>
              </ul>
            </TableRow>
            <TableRow title={t("row_ttl_rmpd_chl")}>
              <ul>
                <li>
                  <Cell
                    label={t("lbl_resv_no")}
                    dataTyp="C"
                    name="rmPdNo"
                    value={filters.rmPdNo}
                    onChange={(e) => onChange("rmPdNo", e.currentTarget.value)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rmpd_chl")}</label>
                  <LodChlSelect
                    isReset={!filters.lodChlCd}
                    select={(lodChlCd) => onSelect("lodChlCd", lodChlCd)}
                  />
                </li>
                <li>
                  {/* <DatePick
                    startNm={"sellSDt"}
                    endNm={"sellSDt"}
                    defaultValue={[filters.sellSDt, filters.sellSDt]}
                    onPickDate={onPickDate}
                  /> */}
                  <DateRangePicker
                    startNm={"sellSDt"}
                    endNm={"sellEDt"}
                    defaultStart={filters.sellSDt}
                    defaultEnd={filters.sellEDt}
                    onChange={onPickDate}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_sell_yn")}</label>
                  <div className="flex">
                    <Radio
                      label={"판매"}
                      id={"Y"}
                      name={"sellYn"}
                      checked={filters.sellYn === "Y"}
                      onChange={(e) => onChange("sellYn", "Y")}
                    />
                    <Radio
                      label={"판매중지"}
                      id={"N"}
                      name={"sellYn"}
                      checked={filters.sellYn === "N"}
                      onChange={(e) => onChange("sellYn", "N")}
                    />
                  </div>
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}
